import React from 'react'
import { useTranslation } from 'react-i18next'

import SubscriptionDetail from 'adminDashboard/companySettings/subscription/components/SubscriptionDetail'
import { Col, Row } from 'antd'

import { ACHDetails } from 'core/application/adminDashboard/companySettings/subscription/subscriptionDetails'

interface ViewACHInfoProps {
  paymentDetails: ACHDetails
}

const ViewACHInfo: React.FC<ViewACHInfoProps> = ({ paymentDetails }) => {
  const { t: translate } = useTranslation()
  return (
    <>
      <Row>
        <Col md={12}>
          <SubscriptionDetail
            title={translate('admin-dashboard.company-settings.subscription.accunt-type')}
            description={paymentDetails.accountType}
          />
        </Col>
        <Col md={12}>
          <SubscriptionDetail
            title={translate('admin-dashboard.company-settings.subscription.routing-number')}
            description={paymentDetails.accountNumber}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <SubscriptionDetail
            title={translate('admin-dashboard.company-settings.subscription.bank-routing-number')}
            description={paymentDetails.bankRoutingNumber}
          />
        </Col>
        <Col md={12}>
          <SubscriptionDetail
            title={translate('admin-dashboard.company-settings.subscription.name-on-account')}
            description={paymentDetails.nameOnAccount}
          />
        </Col>
      </Row>
    </>
  )
}

export default ViewACHInfo
